import { SearchUserHit, User } from 'lib-shared-types-api';

import UserItem from './items/UserItem';
import type { UserItemType } from './items/UserItem';

type PropsT = {
  index: number;
  phoneUtil: any;
  profile: User;
  editUser: (user: SearchUserHit) => void;
  fromNumberFormat: string;
  canMakeOutBoundCall: boolean;
  highlightedIndex: number | null;
  user: SearchUserHit;
  makeCallClickHandler: (user: SearchUserHit) => Promise<void>;
  userType: UserItemType;
};

const ListUsers = (listUsersProps: PropsT) => {
  let highlighted = false;
  if (listUsersProps.highlightedIndex === listUsersProps.index) {
    highlighted = true;
  }

  return (
    <UserItem
      highlighted={highlighted}
      fromNumberFormat={listUsersProps.fromNumberFormat}
      user={listUsersProps.user}
      editUser={listUsersProps.editUser}
      makeCall={listUsersProps.makeCallClickHandler}
      canMakeOutBoundCall={listUsersProps.canMakeOutBoundCall}
      userType={listUsersProps.userType}
    />
  );
};

export default ListUsers;
